import { useState, useEffect, useRef } from "react";
import scenariosData from "./magicbench_scenarios.json";
import googleDefaultRun1 from "./Coin_Through_Table-run_id_Run_1_google_gemini-3.1-pro-preview.run.json";
import anthropicDefaultRun1 from "./Coin_Through_Table-run_id_Run_1_anthropic_claude-opus-4-6default.run.json";
import openAiDefaultRun1 from "./Coin_Through_Table-run_id_Run_1_openai_gpt-5.4-2026-03-05.run.json";
import googleDefaultRun2 from "./The_Invisible_Deck-run_id_Run_1_google_gemini-3.1-pro-preview.run.json";
import anthropicDefaultRun2 from "./The_Invisible_Deck-run_id_Run_1_anthropic_claude-opus-4-6default.run.json";
import openAiDefaultRun2 from "./The_Invisible_Deck-run_id_Run_1_openai_gpt-5.4-2026-03-05.run.json";
import googleDefaultRun3 from "./The_Ambitious_Card-run_id_Run_1_google_gemini-3.1-pro-preview.run.json";
import anthropicDefaultRun3 from "./The_Ambitious_Card-run_id_Run_1_anthropic_claude-opus-4-6default.run.json";
import openAiDefaultRun3 from "./The_Ambitious_Card-run_id_Run_1_openai_gpt-5.4-2026-03-05.run.json";
import googleDefaultRun4 from "./The_Book_Test-run_id_Run_1_google_gemini-3.1-pro-preview.run.json";
import anthropicDefaultRun4 from "./The_Book_Test-run_id_Run_1_anthropic_claude-opus-4-6default.run.json";
import openAiDefaultRun4 from "./The_Book_Test-run_id_Run_1_openai_gpt-5.4-2026-03-05.run.json";
import googleDefaultRun5 from "./Rubber_Band_Through_Thumb-run_id_Run_1_google_gemini-3.1-pro-preview.run.json";
import anthropicDefaultRun5 from "./Rubber_Band_Through_Thumb-run_id_Run_1_anthropic_claude-opus-4-6default.run.json";
import openAiDefaultRun5 from "./Rubber_Band_Through_Thumb-run_id_Run_1_openai_gpt-5.4-2026-03-05.run.json";

const COLORS = {
  accent: "#6C5CE7",
  accentLight: "#A29BFE",
  accentBg: "#F0EEFF",
  teal: "#00B894",
  tealBg: "#E0F8F2",
  coral: "#E17055",
  coralBg: "#FDEAE5",
  amber: "#FDCB6E",
  amberBg: "#FFF8E7",
  dark: "#2D3436",
  mid: "#636E72",
  light: "#B2BEC3",
  bg: "#FAFAFA",
  header_accent: "#D9B56D",
  header_accentLight: "#F2D69A",
  header_accentBg: "#000612",
  header_accentBgHover: "rgb(255 198 72)",
  header_teal: "#55D6C2",
  header_tealBg: "#102A2B",
  header_coral: "#F29C7A",
  header_coralBg: "#2A1917",
  header_amber: "#F0C56C",
  header_amberBg: "#2A2414",
  header_dark: "#F6F1E8",
  header_mid: "#B7C0D5",
  header_light: "#7C879D",
  header_purple: "#BF00FF",
  header_bg: "#07111F",
  header_panel: "#0D1728",
  header_panelAlt: "#101D31",
  header_border: "#22314A",
  header_borderSoft: "#1A2638",
};

const TASKS = [
  { name: "Effect Recognition", weight: "10%", type: "MCQ", icon: "1", desc: "Classify what the audience experienced", color: "#6C5CE7", bg: "#F0EEFF" },
  { name: "Violation Identification", weight: "10%", type: "MCQ", icon: "2", desc: "Which physical/social rules were violated", color: "#0984E3", bg: "#E3F2FD" },
  { name: "Best Explanation", weight: "20%", type: "Open + Judge", icon: "3", desc: "Explain the secret method", color: "#00B894", bg: "#E0F8F2" },
  { name: "Belief Trace", weight: "25%", type: "Open + Judge", icon: "4", desc: "What does the audience believe at each step", color: "#E17055", bg: "#FDEAE5" },
  { name: "Metacognitive Calibration", weight: "10%", type: "Open + Judge", icon: "5", desc: "Rate confidence and acknowledge uncertainty", color: "#FDCB6E", bg: "#FFF8E7" },
  { name: "Counterfactual Reasoning", weight: "25%", type: "Open + Judge", icon: "6", desc: "What if conditions changed?", color: "#D63031", bg: "#FCE4E4" },
];

const PROFILE_DIMS = [
  { name:"Recognition", weight:"10%", color:"#6C5CE7", bg:"#F0EEFF", tasks:["Effect Recognition"], desc:"Can the model parse and classify what the audience experienced?", measures:"Event segmentation, perceptual encoding, effect-type classification" },
  { name:"Causal inference", weight:"30%", color:"#0984E3", bg:"#E3F2FD", tasks:["Violation Identification","Best Explanation"], desc:"Can the model identify what rules were broken and explain the hidden mechanism?", measures:"Violation detection, method explanation, causal chain reconstruction" },
  { name:"Deception modeling", weight:"25%", color:"#E17055", bg:"#FDEAE5", tasks:["Belief Trace"], desc:"Can the model separate what the audience believes from what is actually happening?", measures:"Perspective-taking, belief-state tracking, theory of mind across all steps" },
  { name:"Metacognitive calibration", weight:"10%", color:"#FDCB6E", bg:"#FFF8E7", tasks:["Metacognitive Calibration"], desc:"Can the model express well-calibrated uncertainty and resist overconfidence?", measures:"Confidence assessment, uncertainty acknowledgment, alternative identification" },
  { name:"Transfer / robustness", weight:"25%", color:"#D63031", bg:"#FCE4E4", tasks:["Counterfactual Reasoning"], desc:"Can the model reason about mechanism survival under changed conditions?", measures:"Counterfactual simulation, mechanism generalization, held-out family performance" },
];

const FACULTIES = [
  "Perception", "Attention", "Memory", "Reasoning", "Metacognition",
  "Executive Functions", "Social Cognition", "Learning", "Problem Solving", "Generation"
];
const FAC_COLORS = ["#6C5CE7","#0984E3","#00B894","#E17055","#D63031","#FDCB6E","#E84393","#00CEC9","#636E72","#A29BFE"];

const sortRunsByScore = (runs) =>
  [...runs].sort(
    (a, b) => (b.results?.[0]?.numericResult?.value || 0) - (a.results?.[0]?.numericResult?.value || 0)
  );

const EXAMPLE_OPTIONS = [
  {
    id: "coin-through-table",
    label: "Coin Through Table",
    scenarioId: "PEN-01",
    blurb: "Compare how different models reason through the same penetration scenario across all six subtasks.",
    observations: [],
    runs: sortRunsByScore([anthropicDefaultRun1, openAiDefaultRun1, googleDefaultRun1]),
  },
  {
    id: "the-invisible-deck",
    label: "The Invisible Deck",
    scenarioId: "MEN-07",
    blurb: "Compare how different models reason through the same mentalism scenario across all six subtasks.",
    observations: [],
    runs: sortRunsByScore([anthropicDefaultRun2, openAiDefaultRun2, googleDefaultRun2]),
  },
  {
    id: "the-ambitious-card",
    label: "The Ambitious Card",
    scenarioId: "TRN-01",
    blurb: "Compare how different models reason through the same transformation scenario across all six subtasks.",
    observations: [],
    runs: sortRunsByScore([anthropicDefaultRun3, openAiDefaultRun3, googleDefaultRun3]),
  },
  {
    id: "the-book-test",
    label: "The Book Test",
    scenarioId: "MEN-01",
    blurb: "Compare how different models reason through the same mentalism scenario across all six subtasks.",
    observations: [],
    runs: sortRunsByScore([anthropicDefaultRun4, openAiDefaultRun4, googleDefaultRun4]),
  },
  {
    id: "rubber-band-through-thumb",
    label: "Rubber Band Through Thumb",
    scenarioId: "PEN-04",
    blurb: "Compare how different models reason through the same penetration scenario across all six subtasks.",
    observations: [],
    runs: sortRunsByScore([anthropicDefaultRun5, openAiDefaultRun5, googleDefaultRun5]),
  },
];


const EFFECT_COLORS = {
  vanish: "#6C5CE7",
  appearance: "#00B894",
  transposition: "#E17055",
  transformation: "#D63031",
  levitation: "#0984E3",
  penetration: "#00CEC9",
  prediction: "#FDCB6E",
  mentalism: "#E84393",
  restoration: "#636E72",
  control: "#A29BFE",
};

const formatLabel = (value) =>
  value
    .split("_")
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1))
    .join(" ");

const SCENARIOS = scenariosData;
const HERO_IMAGE_SRC = "/MagicBench/magicbench-hero.png";
const MOBILE_BREAKPOINT = 768;
const SECTION_SCROLL_OFFSET = 40;
const LEADERBOARD = [
  { rank: 1, model: "Claude Opus 4.6", provider: "Anthropic", score: 0.783 },
  { rank: 2, model: "Claude Opus 4.5", provider: "Anthropic", score: 0.772 },
  { rank: 3, model: "Claude Opus 4.7", provider: "Anthropic", score: 0.771 },
  { rank: 4, model: "GPT-5.5", provider: "OpenAI", score: 0.763 },
  { rank: 5, model: "Gemini 3.1 Pro Preview", provider: "Google", score: 0.754 },
  { rank: 6, model: "Gemini 2.5 Pro", provider: "Google", score: 0.727 },
  { rank: 7, model: "Claude Sonnet 4.6", provider: "Anthropic", score: 0.714 },
  { rank: 8, model: "GPT-5.4", provider: "OpenAI", score: 0.692 },
  { rank: 9, model: "GLM-5", provider: "Zhipu", score: 0.674 },
  { rank: 10, model: "DeepSeek V3.2", provider: "DeepSeek", score: 0.655 },
  { rank: 11, model: "Gemma 4 31B", provider: "Google", score: 0.650 },
  { rank: 12, model: "Claude Haiku 4.5", provider: "Anthropic", score: 0.555 },
  { rank: 13, model: "Qwen 3 Next 80B Thinking", provider: "Qwen", score: 0.466 },
];

const DATASET_SUMMARY = (() => {
  const effectCounts = new Map();
  const methodFamilies = new Set();
  const trickFamilies = new Set();
  const tomCounts = new Map();
  const difficultyAxes = Object.keys(SCENARIOS[0].difficulty);
  let maxCounterfactual = 0;

  for (const scenario of SCENARIOS) {
    effectCounts.set(scenario.effect_type, (effectCounts.get(scenario.effect_type) || 0) + 1);
    trickFamilies.add(scenario.trick_family);
    for (const family of scenario.method_families || []) {
      methodFamilies.add(family);
    }

    const tomNeed = scenario.difficulty?.tom_need || 0;
    tomCounts.set(tomNeed, (tomCounts.get(tomNeed) || 0) + 1);
    maxCounterfactual = Math.max(maxCounterfactual, scenario.difficulty?.counterfactual || 0);
  }

  const effectDistribution = Array.from(effectCounts.entries())
    .sort((a, b) => b[1] - a[1] || a[0].localeCompare(b[0]))
    .map(([effect, count]) => ({
      key: effect,
      name: formatLabel(effect),
      count,
      color: EFFECT_COLORS[effect] || COLORS.accentLight,
    }));

  return {
    totalScenarios: SCENARIOS.length,
    totalTasks: SCENARIOS.length * TASKS.length,
    effectTypeCount: effectDistribution.length,
    methodFamilyCount: methodFamilies.size,
    difficultyAxisCount: difficultyAxes.length,
    trickFamilyCount: trickFamilies.size,
    tomCounts: Object.fromEntries(tomCounts),
    effectDistribution,
    mostCommonEffect: effectDistribution[0],
    maxCounterfactual,
    maxCounterfactualCount: SCENARIOS.filter(
      (scenario) => scenario.difficulty?.counterfactual === maxCounterfactual
    ).length,
  };
})();

function NavBar({ active, onNav }) {
  const items = ["Overview", "Tasks", "Dataset", "Evaluation", "Leaderboard", "References"];
  const [isMobile, setIsMobile] = useState(() =>
    typeof window !== "undefined" ? window.innerWidth < MOBILE_BREAKPOINT : false
  );
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < MOBILE_BREAKPOINT;
      setIsMobile(mobile);
      if (!mobile) {
        setIsDrawerOpen(false);
      }
    };

    handleResize();
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const handleNavClick = (item) => {
    onNav(item);
    setIsDrawerOpen(false);
  };

  return (
    <nav style={{ position: "sticky", top: 0, zIndex: 100, background: COLORS.header_accentBg, backdropFilter: "blur(12px)", borderBottom: `1px solid ${COLORS.header_border}`, padding: "0 16px" }}>
      <div style={{ maxWidth: 1100, margin: "0 auto", display: "flex", alignItems: "center", justifyContent: "space-between", gap: 12, padding: "12px 0" }}>
        <div style={{ fontWeight: 700, fontSize: 18, color: COLORS.header_accent, letterSpacing: -0.5, display: "flex", alignItems: "center", gap: 8 }}>
          <span style={{ fontSize: 22 }}>&#9824;</span> MagicBench
        </div>
        {isMobile ? (
          <button
            onClick={() => setIsDrawerOpen((open) => !open)}
            aria-label={isDrawerOpen ? "Close navigation menu" : "Open navigation menu"}
            aria-expanded={isDrawerOpen}
            style={{
              width: 40,
              height: 40,
              borderRadius: 10,
              border: `1px solid ${COLORS.header_border}`,
              background: COLORS.header_panel,
              color: COLORS.header_accent,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              fontSize: 20,
              lineHeight: 1,
            }}
          >
            {isDrawerOpen ? "×" : "☰"}
          </button>
        ) : (
          <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", flex: "1 1 480px", flexWrap: "wrap", gap: 12 }}>
            <div style={{ display: "flex", alignItems: "center", justifyContent: "flex-end", flex: "1 1 360px", flexWrap: "wrap", gap: "6px 16px" }}>
              {items.map(item => (
                <button key={item} onClick={() => handleNavClick(item)}
                  style={{ background: "none", border: "none", cursor: "pointer", fontSize: 13, fontWeight: active === item ? 600 : 400, color: active === item ? COLORS.header_accent : COLORS.header_mid, borderBottom: active === item ? `2px solid ${COLORS.header_accent}` : "2px solid transparent", padding: "8px 0", transition: "all 0.2s" }}>
                  {item}
                </button>
              ))}
            </div>
          </div>
        )}
      </div>
      {isMobile && isDrawerOpen && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            background: "rgba(3, 9, 21, 0.48)",
            zIndex: 99,
          }}
          onClick={() => setIsDrawerOpen(false)}
        >
          <div
            style={{
              position: "absolute",
              top: 68,
              right: 16,
              left: 16,
              background: COLORS.header_panel,
              border: `1px solid ${COLORS.header_border}`,
              borderRadius: 16,
              padding: 16,
              boxShadow: "0 24px 60px rgba(0, 0, 0, 0.35)",
              display: "grid",
              gap: 8,
            }}
            onClick={(event) => event.stopPropagation()}
          >
            {items.map((item) => (
              <button
                key={item}
                onClick={() => handleNavClick(item)}
                style={{
                  background: active === item ? COLORS.header_borderSoft : "transparent",
                  border: `1px solid ${active === item ? COLORS.header_border : "transparent"}`,
                  color: active === item ? COLORS.header_accent : COLORS.header_dark,
                  cursor: "pointer",
                  fontSize: 14,
                  fontWeight: active === item ? 600 : 500,
                  borderRadius: 10,
                  padding: "12px 14px",
                  textAlign: "left",
                }}
              >
                {item}
              </button>
            ))}
            <a
              href="https://github.com/twweeb/MagicBench"
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => setIsDrawerOpen(false)}
              style={{
                fontSize: 13,
                padding: "10px 14px",
                border: `1px solid ${COLORS.header_accent}`,
                borderRadius: 10,
                color: COLORS.header_accent,
                textDecoration: "none",
                fontWeight: 600,
                textAlign: "center",
                marginTop: 4,
              }}
            >
              GitHub
            </a>
          </div>
        </div>
      )}
    </nav>
  );
}

function Hero({ summary }) {
  const heroSubtitle = "Testing adversarial reasoning, metacognition, theory of mind, and causal inference through magic-trick understanding.";
  const [typedSubtitle, setTypedSubtitle] = useState("");
  const [hookVisible, setHookVisible] = useState(false);
  const [titleVisible, setTitleVisible] = useState(false);
  const [subtitleVisible, setSubtitleVisible] = useState(false);

  useEffect(() => {
    let index = 0;
    let interval;
    const t1 = setTimeout(() => setHookVisible(true), 300);
    const t2 = setTimeout(() => setTitleVisible(true), 3000);
    const t3 = setTimeout(() => setSubtitleVisible(true), 2200);
    const t4 = setTimeout(() => {
      interval = window.setInterval(() => {
        index += 1;
        setTypedSubtitle(heroSubtitle.slice(0, index));
        if (index >= heroSubtitle.length) {
          window.clearInterval(interval);
        }
      }, 40);
    }, 4700);

    return () => { clearTimeout(t1); clearTimeout(t2); clearTimeout(t3); clearTimeout(t4); window.clearInterval(interval); };

  }, [heroSubtitle]);

  const heroCtaStyle = {
    fontSize: 13,
    padding: "8px 20px",
    borderRadius: 8,
    background: COLORS.header_accent,
    color: "#fff",
    textDecoration: "none",
    fontWeight: 600,
    transition: "background-color 0.2s ease",
  };

  const handleHeroCtaMouseEnter = (event) => {
    event.currentTarget.style.backgroundColor = COLORS.header_accentBgHover;
  };

  const handleHeroCtaMouseLeave = (event) => {
    event.currentTarget.style.backgroundColor = COLORS.header_accent;
  };

  return (
    <section style={{ padding: "clamp(48px, 8vw, 72px) 24px clamp(40px, 6vw, 56px)", background: COLORS.header_accentBg }}>
      <div
        style={{
          maxWidth: 1180,
          margin: "0 auto",
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))",
          gap: "clamp(24px, 4vw, 40px)",
          alignItems: "center",
        }}
      >
        <div>
          <img
            src={HERO_IMAGE_SRC}
            alt="MagicBench hero illustration showing a card trick surrounded by cognitive abilities"
            style={{ width: "100%", display: "block", borderRadius: 24, boxShadow: "0 24px 60px rgba(20, 24, 40, 0.18)", aspectRatio: "1 / 1", objectFit: "cover", WebkitUserDrag: "none", WebkitUserSelect: "none", MozUserSelect: "none", msUserSelect: "none", userSelect: "none" }}
          />
        </div>
        <div>
          <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.header_accent, letterSpacing: 1.5, textTransform: "uppercase", marginBottom: 12 }}>
              <span style={{ opacity:hookVisible?1:0, transform:hookVisible?"translateY(0)":"translateY(20px)", transition:"all 0.8s ease-out" }}>
              Can LLMs See Through 
              </span>
              {" "}
              <span style={{ color: COLORS.header_purple, opacity:hookVisible?1:0, transform:hookVisible?"translateY(0)":"translateY(40px)", transition:"all 0.8s ease-out 1.5s" }}>
              Deception?
              </span>
          </div>
          <h1 style={{ fontSize: "clamp(36px, 7vw, 52px)", fontWeight: 800, color: COLORS.header_dark, lineHeight: 1.1, margin: "0 0 16px", letterSpacing: -1.2, opacity:titleVisible?1:0, transform:titleVisible?"translateY(0)":"translateY(16px)", transition:"all 0.6s ease-out"}}>
            MagicBench
          </h1>
          <p
            aria-label={heroSubtitle}
            style={{ fontSize: "clamp(17px, 2.8vw, 20px)", color: COLORS.header_mid, maxWidth: 560, margin: "0 0 32px", lineHeight: 1.6, minHeight: "4.8em", opacity:subtitleVisible?1:0, transform:subtitleVisible?"translateY(0)":"translateY(16px)", transition:"all 0.6s ease-out 0.9s" }}
          >
            {typedSubtitle}
            <span style={{ opacity: typedSubtitle.length < heroSubtitle.length ? 1 : 0, marginLeft: 2 }}>|</span>
          </p>
          <div style={{ display: "flex", flexWrap: "wrap", gridTemplateColumns: "repeat(auto-fit, minmax(160px, 1fr))", gap: 12 }}>
            {[
              { label: `${summary.totalScenarios} scenarios`, sub: `${summary.effectTypeCount} effect types` },
              { label: `${summary.totalTasks} tasks`, sub: `${TASKS.length} per scenario` },
              { label: `5 profiles`, sub: "multi-dimensional cognitive evaluation" },
            ].map((s, i) => (
              <div key={i} style={{ background: "#fff", border: "1px solid #eee", borderRadius: 12, padding: "16px 20px", minWidth: 110, flex: "1 1 0%", boxShadow: "0 10px 30px rgba(108, 92, 231, 0.08)" }}>
                <div style={{ fontSize: "clamp(20px, 4vw, 22px)", fontWeight: 700, color: COLORS.header_accent }}>{s.label}</div>
                <div style={{ fontSize: 12, color: COLORS.header_light, marginTop: 2 }}>{s.sub}</div>
              </div>
            ))}
          </div>
          <div style={{ display:"flex", gap:10, justifyContent:"center", marginTop:30, float: "left" }}>
            <a href="https://github.com/twweeb/MagicBench" target="_blank" rel="noopener noreferrer" style={heroCtaStyle} onMouseEnter={handleHeroCtaMouseEnter} onMouseLeave={handleHeroCtaMouseLeave}>GitHub</a>
            <a href="https://huggingface.co/datasets/hsiung/MagicBench" target="_blank" rel="noopener noreferrer" style={heroCtaStyle} onMouseEnter={handleHeroCtaMouseEnter} onMouseLeave={handleHeroCtaMouseLeave}>Dataset</a>
	    <a href="https://www.kaggle.com/benchmarks/lhsiung/magicbench" target="_blank" rel="noopener noreferrer" style={heroCtaStyle} onMouseEnter={handleHeroCtaMouseEnter} onMouseLeave={handleHeroCtaMouseLeave}>Kaggle Benchmark</a>
          </div>
        </div>
      </div>
    </section>
  );
}

const ABSTRACT = `Current large language model (LLM) benchmarks predominantly evaluate reasoning in cooperative, 
fully observable settings, leaving critical gaps in assessing performance under adversarial information manipulation, 
partial observability, and social deception. We introduce MagicBench, a deception-sensitive cognitive benchmark that 
leverages magic-trick understanding as an adversarial probe for LLM cognition. Magic tricks are uniquely suited for this purpose: 
they are observer-dependent stimuli in which a performer deliberately manipulates attention, memory, and inference to induce 
false beliefs, requiring the observer to integrate causal reasoning, theory of mind, metacognitive calibration, and 
counterfactual analysis to understand the underlying method. MagicBench comprises 50 scenarios spanning 10 effect types, each 
generating 6 task types (300 tasks total) that map onto a weighted scoring framework. 
Each scenario is annotated with 5 difficulty axes (perceptual complexity, hidden steps, social context dependence, 
theory-of-mind need, and counterfactual demand) and per-task cognitive faculty tags, enabling fine-grained diagnostic profiles. 
MagicBench targets the evaluation gaps most emphasized by recent AGI frameworks — attention, metacognition, social cognition, 
and executive functions — and is designed to reveal the jagged capability profiles that single-score benchmarks obscure.`;
function Overview() {
  return (
    <div>
      <div style={{ fontSize: "clamp(13px, 2vw, 14px)", color: COLORS.mid, lineHeight: 1.6 , textAlign: "justify"}}>{ABSTRACT}</div>
    </div>
  );
}

function Section({ id, title, subtitle, children, bg }) {
  return (
    <section id={id} style={{ padding: "clamp(44px, 7vw, 64px) 24px", background: bg || "#fff" }}>
      <div style={{ maxWidth: 1000, margin: "0 auto" }}>
        {title && <h2 style={{ fontSize: "clamp(24px, 5vw, 28px)", fontWeight: 700, color: COLORS.dark, margin: "0 0 6px", letterSpacing: -0.5 }}>{title}</h2>}
        {subtitle && <div style={{ fontSize: "clamp(14px, 2.4vw, 15px)", color: COLORS.mid, margin: "0 0 32px", lineHeight: 1.6 }}>{subtitle}</div>}
        {children}
      </div>
    </section>
  );
}

function TaskCards() {
  return (
    <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(240px, 1fr))", gap: 16 }}>
      {TASKS.map((t, i) => (
        <div key={i} style={{ border: "1px solid #eee", borderRadius: 12, padding: "20px", background: "#fff", borderTop: `3px solid ${t.color}` }}>
          <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
            <div style={{ width: 28, height: 28, borderRadius: 7, background: t.bg, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 13, fontWeight: 700, color: t.color }}>{t.icon}</div>
            <div style={{ fontSize: 14, fontWeight: 600, color: COLORS.dark }}>{t.name}</div>
          </div>
          <div style={{ fontSize: 12, color: COLORS.mid, lineHeight: 1.5, marginBottom: 10 }}>{t.desc}</div>
          <div style={{ display: "flex", gap: 6 }}>
            <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 4, background: t.bg, color: t.color, fontWeight: 600 }}>{t.weight}</span>
            <span style={{ fontSize: 10, padding: "2px 8px", borderRadius: 4, background: "#f5f5f5", color: COLORS.mid, fontWeight: 500 }}>{t.type}</span>
          </div>
        </div>
      ))}
    </div>
  );
}

function ProfileMap() {
  const [active, setActive] = useState(null);
  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16, flexWrap:"wrap" }}>
        {PROFILE_DIMS.map((d,i) => (
          <button key={i} onClick={() => setActive(active===i?null:i)} style={{ flex:1, padding:"10px 8px", borderRadius:8, cursor:"pointer", border:active===i?`2px solid ${d.color}`:"1.5px solid #e0e0e0", background:active===i?d.bg:"#fff", transition:"all 0.2s" }}>
            <div style={{ fontSize:11, fontWeight:600, color:active===i?d.color:COLORS.dark, marginTop:2, lineHeight:1.3 }}>{d.name}</div>
          </button>
        ))}
      </div>
      {active !== null && (
        <div style={{ padding:20, borderRadius:10, border:`1.5px solid ${PROFILE_DIMS[active].color}40`, background:PROFILE_DIMS[active].bg }}>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12 }}>
            <div style={{ width:32, height:32, borderRadius:8, background:PROFILE_DIMS[active].color, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:14, fontWeight:700 }}>{active+1}</div>
            <div>
              <div style={{ fontSize:15, fontWeight:700, color:PROFILE_DIMS[active].color }}>{PROFILE_DIMS[active].name}</div>
              <div style={{ fontSize:11, color:COLORS.mid }}>{PROFILE_DIMS[active].weight} of total score</div>
            </div>
          </div>
          <div style={{ fontSize:13, color:COLORS.dark, lineHeight:1.6, marginBottom:12 }}>{PROFILE_DIMS[active].desc}</div>
          <div style={{ marginBottom:12 }}>
            <div style={{ fontSize:11, fontWeight:600, color:COLORS.mid, marginBottom:6 }}>Contributing tasks</div>
            <div style={{ display:"flex", gap:6, flexWrap:"wrap" }}>
              {PROFILE_DIMS[active].tasks.map((t,j) => {
                const m = TASKS.find(tk => tk.name===t);
                return <span key={j} style={{ fontSize:11, padding:"4px 10px", borderRadius:5, background:m?m.color+"18":"#f0f0f0", color:m?m.color:COLORS.mid, fontWeight:600, border:`1px solid ${m?m.color+"30":"#ddd"}` }}>{t}</span>;
              })}
            </div>
          </div>
          <div>
            <div style={{ fontSize:11, fontWeight:600, color:COLORS.mid, marginBottom:4 }}>What it measures</div>
            <div style={{ fontSize:12, color:COLORS.mid, lineHeight:1.5 }}>{PROFILE_DIMS[active].measures}</div>
          </div>
        </div>
      )}
      {active === null}
    </div>
  );
}


function EffectDistribution({ effects }) {
  const max = Math.max(...effects.map(e => e.count));
  return (
    <div>
      {effects.map((e) => (
        <div key={e.key} style={{ display: "grid", gridTemplateColumns: "minmax(72px, 100px) 1fr auto", alignItems: "center", gap: 12, marginBottom: 8 }}>
          <div style={{ fontSize: 12, color: COLORS.mid, textAlign: "right" }}>{e.name}</div>
          <div style={{ flex: 1, height: 20, background: "#f5f5f5", borderRadius: 4, overflow: "hidden" }}>
            <div style={{ width: `${(e.count / max) * 100}%`, height: "100%", background: e.color, borderRadius: 4, transition: "width 0.5s" }} />
          </div>
          <div style={{ width: 24, fontSize: 13, fontWeight: 600, color: COLORS.dark }}>{e.count}</div>
        </div>
      ))}
    </div>
  );
}

function FacultyWheel() {
  return (
    <div style={{ display: "flex", flexWrap: "wrap", gap: 8, justifyContent: "center" }}>
      {FACULTIES.map((f, i) => {
        const colors = ["#6C5CE7","#0984E3","#00B894","#E17055","#D63031","#FDCB6E","#E84393","#00CEC9","#636E72","#A29BFE"];
        return (
          <div key={i} style={{ padding: "8px 16px", borderRadius: 20, border: `1.5px solid ${colors[i]}40`, background: colors[i] + "10", fontSize: 12, fontWeight: 500, color: colors[i] }}>
            {f}
          </div>
        );
      })}
    </div>
  );
}

const sampleDifficultyScenarios = (scenarios, count = 3) => {
  if (scenarios.length <= count) {
    return scenarios;
  }

  if (count === 1) {
    return [scenarios[Math.floor(scenarios.length / 2)]];
  }

  const picked = [];
  const usedIndexes = new Set();

  for (let i = 0; i < count; i += 1) {
    let index = Math.round((i * (scenarios.length - 1)) / (count - 1));

    while (usedIndexes.has(index) && index < scenarios.length - 1) {
      index += 1;
    }
    while (usedIndexes.has(index) && index > 0) {
      index -= 1;
    }

    if (!usedIndexes.has(index)) {
      usedIndexes.add(index);
      picked.push(scenarios[index]);
    }
  }

  return picked;
};

const getDifficultyExamples = (difficultyKey, count = 3) => {
  const scoredScenarios = SCENARIOS
    .filter((scenario) => typeof scenario.difficulty?.[difficultyKey] === "number")
    .sort(
      (a, b) =>
        a.difficulty[difficultyKey] - b.difficulty[difficultyKey] ||
        a.id.localeCompare(b.id)
    );

  if (!scoredScenarios.length) {
    return { examples_low: [], examples_high: [] };
  }

  const lowScore = scoredScenarios[0].difficulty[difficultyKey];
  const highScore = scoredScenarios[scoredScenarios.length - 1].difficulty[difficultyKey];
  const formatExample = (scenario) =>
    `${scenario.id} ${scenario.title} (${scenario.difficulty[difficultyKey]})`;

  return {
    examples_low: sampleDifficultyScenarios(
      scoredScenarios.filter((scenario) => scenario.difficulty[difficultyKey] === lowScore),
      count
    ).map(formatExample),
    examples_high: sampleDifficultyScenarios(
      scoredScenarios.filter((scenario) => scenario.difficulty[difficultyKey] === highScore),
      count
    ).map(formatExample),
  };
};

const withDifficultyExamples = (difficultyKey, axis) => ({
  ...axis,
  ...getDifficultyExamples(difficultyKey),
});

const DIFF_AXES = [
  withDifficultyExamples("perceptual", {
    name: "Perceptual complexity",
    color: "#6C5CE7",
    bg: "#F0EEFF",
    desc: "How much visual and physical tracking is required to follow the trick's key events.",
    measures: "Object tracking across occlusion, change detection, motion prediction, multi-object monitoring",
    low: "A verbal prediction trick with no physical manipulation — the audience only needs to hear words and see an envelope opened.",
    high: "A rapid card color-change sequence where the performer flips, rotates, and displays a card assembly — the audience must track subtle visual transitions at speed.",
  }),
  withDifficultyExamples("hidden_steps", {
    name: "Hidden steps",
    color: "#0984E3",
    bg: "#E3F2FD",
    desc: "How many concealed operations occur between what the audience sees and the actual method.",
    measures: "Secret transfers, switches, loads, pre-show setups, multi-phase deception chains",
    low: "The Vanishing Ball — only one hidden step: the ball is retained in the hand instead of thrown. Everything else is perception and social cues.",
    high: "The Berglas Effect — memorized stack, psychological forcing of card and number, multiple alternative outs, real-time decision branching, all invisible to the audience.",
  }),
  withDifficultyExamples("social_context", {
    name: "Social context",
    color: "#00B894",
    bg: "#E0F8F2",
    desc: "How much the trick depends on social interaction, audience dynamics, performer-spectator communication, and shared attention.",
    measures: "Verbal framing, audience participation management, social misdirection via gaze/gesture, conversational priming, group dynamics",
    low: "A solo levitation illusion with no audience interaction — the method is purely mechanical and works the same whether anyone is watching or not.",
    high: "The Magician's Choice — the entire method IS the social interaction. The performer reinterprets the spectator's words on the fly using linguistic ambiguity.",
  }),
  withDifficultyExamples("tom_need", {
    name: "Theory of mind need",
    color: "#E17055",
    bg: "#FDEAE5",
    desc: "How much the model must reason about other people's mental states — their beliefs, knowledge, intentions, and perspective — to understand the trick.",
    measures: "Belief-state tracking, perspective separation (audience vs. performer vs. reality), intentional deception modeling, recursive mental-state inference",
    low: "A physical vanish where the coin is palmed — understanding requires spatial reasoning about object locations, not modeling anyone's beliefs.",
    high: "Dual Reality — two groups of people experience different events but each believes they saw the same show. Understanding requires simultaneously modeling what the stage participants know vs. what the seated audience knows vs. what actually happened.",
  }),
  withDifficultyExamples("counterfactual", {
    name: "Counterfactual demand",
    color: "#D63031",
    bg: "#FCE4E4",
    desc: "How much reasoning about hypothetical changes is required to fully understand why the method works and what would break it.",
    measures: "Mechanism-condition dependency analysis, method survival under altered constraints, distinguishing necessary vs. incidental features of the trick",
    low: "The Production Silk — the method (thumb tip concealment) is straightforward; there are few non-obvious conditions that would alter whether it works.",
    high: "The Berglas Effect — understanding requires reasoning about what happens when choices are truly random vs. influenced, when the deck is shuffled vs. stacked, and why the effect only succeeds a fraction of the time. Each counterfactual reveals a different layer of the probabilistic system.",
  }),
];

function DifficultyAxes() {
  const [active, setActive] = useState(null);
  return (
    <div>
      <div style={{ display:"flex", gap:6, marginBottom:16, flexWrap:"wrap" }}>
        {DIFF_AXES.map((d,i) => (
          <button key={i} onClick={() => setActive(active===i?null:i)} style={{ flex:1, minWidth:100, padding:"10px 8px", borderRadius:8, cursor:"pointer", border:active===i?`2px solid ${d.color}`:"1.5px solid #e0e0e0", background:active===i?d.bg:"#fff", transition:"all 0.2s" }}>
            <div style={{ fontSize:11, fontWeight:600, color:active===i?d.color:COLORS.dark, marginTop:2, lineHeight:1.3 }}>{d.name}</div>
          </button>
        ))}
      </div>
      {active !== null && (
        <div style={{ padding:20, borderRadius:10, border:`1.5px solid ${DIFF_AXES[active].color}40`, background:DIFF_AXES[active].bg, marginBottom:12 }}>
          <div style={{ display:"flex", alignItems:"center", gap:10, marginBottom:12 }}>
            <div style={{ width:32, height:32, borderRadius:8, background:DIFF_AXES[active].color, display:"flex", alignItems:"center", justifyContent:"center", color:"#fff", fontSize:14, fontWeight:700 }}>{active+1}</div>
            <div>
              <div style={{ fontSize:15, fontWeight:700, color:DIFF_AXES[active].color }}>{DIFF_AXES[active].name}</div>
              <div style={{ fontSize:11, color:COLORS.mid }}>Rated 1 (low) to 5 (high) per scenario</div>
            </div>
          </div>
          <div style={{ fontSize:13, color:COLORS.dark, lineHeight:1.6, marginBottom:16 }}>{DIFF_AXES[active].desc}</div>
          <div style={{ marginBottom:16 }}>
            <div style={{ fontSize:11, fontWeight:600, color:COLORS.mid, marginBottom:4 }}>What it measures</div>
            <div style={{ fontSize:12, color:COLORS.mid, lineHeight:1.5 }}>{DIFF_AXES[active].measures}</div>
          </div>
          <div style={{ display:"grid", gridTemplateColumns:"1fr 1fr", gap:12 }}>
            <div style={{ padding:12, background:"rgba(255,255,255,0.7)", borderRadius:8, border:"1px solid rgba(0,0,0,0.06)" }}>
              <div style={{ fontSize:11, fontWeight:600, color:"#00B894", marginBottom:6 }}>Low (1-2): easy for models</div>
              <div style={{ fontSize:12, color:COLORS.dark, lineHeight:1.5, marginBottom:8 }}>{DIFF_AXES[active].low}</div>
              <div style={{ fontSize:10, color:COLORS.mid }}>
                {DIFF_AXES[active].examples_low.map((e,i) => <div key={i} style={{ marginBottom:2 }}>{e}</div>)}
              </div>
            </div>
            <div style={{ padding:12, background:"rgba(255,255,255,0.7)", borderRadius:8, border:"1px solid rgba(0,0,0,0.06)" }}>
              <div style={{ fontSize:11, fontWeight:600, color:"#D63031", marginBottom:6 }}>High (4-5): challenging for models</div>
              <div style={{ fontSize:12, color:COLORS.dark, lineHeight:1.5, marginBottom:8 }}>{DIFF_AXES[active].high}</div>
              <div style={{ fontSize:10, color:COLORS.mid }}>
                {DIFF_AXES[active].examples_high.map((e,i) => <div key={i} style={{ marginBottom:2 }}>{e}</div>)}
              </div>
            </div>
          </div>
        </div>
      )}
      {active === null}
    </div>
  );
}

function ScenarioTable({ scenarios, totalScenarios }) {
  const [sort, setSort] = useState(null);
  const [showDescriptions, setShowDescriptions] = useState(false);
  const sorted = [...scenarios].sort((a, b) => {
    if (sort === "tom") return b.tom - a.tom;
    if (sort === "effect") return a.effect.localeCompare(b.effect);
    return 0;
  });
  const displayed = sorted.slice(0, 15);

  return (
    <div>
      <div style={{ display: "flex", gap: 8, marginBottom: 12, flexWrap: "wrap" }}>
        <button onClick={() => setSort(null)} style={{ fontSize: 11, padding: "4px 10px", borderRadius: 4, border: "1px solid #ddd", background: !sort ? COLORS.accentBg : "#fff", color: !sort ? COLORS.accent : COLORS.mid, cursor: "pointer" }}>Default</button>
        <button onClick={() => setSort("tom")} style={{ fontSize: 11, padding: "4px 10px", borderRadius: 4, border: "1px solid #ddd", background: sort === "tom" ? COLORS.accentBg : "#fff", color: sort === "tom" ? COLORS.accent : COLORS.mid, cursor: "pointer" }}>By ToM need</button>
        <button onClick={() => setSort("effect")} style={{ fontSize: 11, padding: "4px 10px", borderRadius: 4, border: "1px solid #ddd", background: sort === "effect" ? COLORS.accentBg : "#fff", color: sort === "effect" ? COLORS.accent : COLORS.mid, cursor: "pointer" }}>By effect type</button>
        <button
          onClick={() => setShowDescriptions((current) => !current)}
          style={{ fontSize: 11, padding: "4px 10px", borderRadius: 4, border: "1px solid #ddd", background: showDescriptions ? COLORS.tealBg : "#fff", color: showDescriptions ? COLORS.teal : COLORS.mid, cursor: "pointer" }}
        >
          {showDescriptions ? "Hide descriptions" : "Show descriptions"}
        </button>
      </div>
      <div style={{ border: "1px solid #eee", borderRadius: 8, overflowX: "auto", overflowY: "hidden" }}>
        <div style={{ display: "grid", gridTemplateColumns: "70px minmax(220px, 1fr) 110px 60px", minWidth: 460, padding: "8px 12px", background: "#f9f9f9", fontSize: 11, fontWeight: 600, color: COLORS.mid }}>
          <div>ID</div><div>Title</div><div>Effect</div><div>ToM</div>
        </div>
        {displayed.map((s) => (
          <div key={s.id} style={{ display: "grid", gridTemplateColumns: "70px minmax(220px, 1fr) 110px 60px", minWidth: 460, padding: "8px 12px", borderTop: "1px solid #f0f0f0", fontSize: 12, alignItems: showDescriptions ? "start" : "center" }}>
            <div style={{ fontWeight: 600, color: COLORS.accent }}>{s.id}</div>
            <div>
              <div style={{ color: COLORS.dark }}>{s.title}</div>
              {showDescriptions && (
                <div style={{ marginTop: 6, color: COLORS.mid, lineHeight: 1.5 }}>
                  <div>{s.description}</div>
                  <div style={{ marginTop: 6 }}>
                    <span style={{ fontSize: 10, fontWeight: 600, color: COLORS.mid }}>Method Families:</span>{" "}
                    {s.methodFamilies.split(",").map((methodFamily) => (
                      <span
                        key={methodFamily.trim()}
                        style={{ fontSize: 10, padding: "2px 6px", borderRadius: 3, background: "#f0f0f0", color: COLORS.mid, marginRight: 4 }}
                      >
                        {formatLabel(methodFamily.trim())}
                      </span>
                    ))}
                  </div>
                </div>
              )}
            </div>
            <div><span style={{ fontSize: 10, padding: "2px 6px", borderRadius: 3, background: "#f0f0f0", color: COLORS.mid }}>{s.effect}</span></div>
            <div>{Array.from({ length: 5 }, (_, j) => <span key={j} style={{ display: "inline-block", width: 8, height: 8, borderRadius: 2, background: j < s.tom ? COLORS.accent : "#eee", marginRight: 2 }} />)}</div>
          </div>
        ))}
        <div style={{ padding: "8px 12px", background: "#f9f9f9", fontSize: 11, color: COLORS.mid, textAlign: "center" }}>
          Showing {displayed.length} of {totalScenarios} scenarios from the dataset <p>(view on <a href="https://huggingface.co/datasets/hsiung/MagicBench" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.accent, textDecoration: "underline" }}>HuggingFace</a>)</p>
        </div>
      </div>
    </div>
  );
}


function ExampleViewer() {
  const [selectedExampleId, setSelectedExampleId] = useState(EXAMPLE_OPTIONS[0]?.id || "");
  const [activeRun, setActiveRun] = useState(0);
  const [expandedReq, setExpandedReq] = useState(null);
  const selectedExample = EXAMPLE_OPTIONS.find((example) => example.id === selectedExampleId) || EXAMPLE_OPTIONS[0];
  const runs = selectedExample?.runs || [];

  useEffect(() => {
    setActiveRun(0);
    setExpandedReq(null);
  }, [selectedExampleId]);

  const parseRun = (run) => {
    const model = run.modelVersion?.slug || "unknown";
    const score = run.results?.[0]?.numericResult?.value ?? 0;
    const task = run.taskVersion?.name || "Unknown Task";
    const def = run.taskVersion?.definition || "";
    const convos = run.conversations || [];
    const mainConvo = convos.find(c => !c.id.startsWith("Response assessment")) || convos[0];
    const judgeConvos = convos.filter(c => c.id.startsWith("Response assessment"));

    // Extract gold answers from task definition code
    const s1GoldMatch = def.match(/_s1_match\.group\(\)\s*==\s*"([A-Z])"/);
    const s1Gold = s1GoldMatch ? s1GoldMatch[1] : null;
    const s2GoldMatch = def.match(/_s2_gold\s*=\s*set\("([^"]+)"\.replace/);
    const s2Gold = s2GoldMatch ? s2GoldMatch[1] : null;

    const SUBTASK_NAMES = [
      "Effect Recognition", "Violation Identification", "Best Explanation",
      "Belief Trace", "Metacognitive Calibration", "Counterfactual Reasoning"
    ];
    const SUBTASK_WEIGHTS = [0.10, 0.10, 0.20, 0.25, 0.10, 0.25];

    const turns = (mainConvo?.requests || []).map((req, i) => {
      const userMsg = req.contents?.find(c => c.role === "CONTENT_ROLE_USER");
      const assistMsg = req.contents?.find(c => c.role === "CONTENT_ROLE_ASSISTANT");
      const prompt = userMsg?.parts?.[0]?.text || "";
      const response = assistMsg?.parts?.[0]?.text || "";
      const latency = req.metrics?.totalBackendLatencyMs || 0;
      const tokens = (req.metrics?.outputTokens || 0);

      // Compute MCQ scoring for tasks 1 and 2
      let mcqResult = null;
      if (i === 0 && s1Gold) {
        const ansMatch = response.trim().toUpperCase().match(/[A-Z]/);
        const ans = ansMatch ? ansMatch[0] : "?";
        mcqResult = { gold: s1Gold, predicted: ans, passed: ans === s1Gold, type: "exact" };
      } else if (i === 1 && s2Gold) {
        const predicted = new Set(response.toUpperCase().match(/[A-G]/g) || []);
        const gold = new Set(s2Gold.replace(/ /g, "").split(","));
        const tp = [...predicted].filter(x => gold.has(x)).length;
        const prec = predicted.size > 0 ? tp / predicted.size : 0;
        const rec = gold.size > 0 ? tp / gold.size : 0;
        const f1 = (prec + rec) > 0 ? 2 * prec * rec / (prec + rec) : 0;
        mcqResult = { gold: s2Gold, predicted: [...predicted].sort().join(", ") || "(none)", passed: f1 >= 1.0, f1: f1, type: "f1" };
      }

      return { prompt, response, latency: Number(latency), tokens, subtask: SUBTASK_NAMES[i] || `Turn ${i+1}`, weight: SUBTASK_WEIGHTS[i] || 0, mcqResult };
    });

    const judges = judgeConvos.map(jc => {
      const jReq = jc.requests?.[0];
      const jUser = jReq?.contents?.find(c => c.role === "CONTENT_ROLE_USER");
      const jAsst = jReq?.contents?.find(c => c.role === "CONTENT_ROLE_ASSISTANT");
      const criteria = jUser?.parts?.[0]?.text || "";
      const rawResult = jAsst?.parts?.[0]?.text || "";
      let parsed = null;
      try {
        const cleaned = rawResult.replace(/^"|"$/g, '').replace(/\\"/g, '"').replace(/\\n/g, '\n');
        parsed = JSON.parse(cleaned);
      } catch { /* ignore */ }
      const focusMatch = criteria.match(/Focus on (Step \d+|Scenario \d+)\./);
      const focus = focusMatch ? focusMatch[1] : null;
      const subtaskHint = criteria.includes("core secret mechanism") ? "Best Explanation"
        : criteria.includes("metacognitive awareness") && criteria.includes("core mechanism") ? "Metacognitive Calibration"
        : focus?.startsWith("Step") ? "Belief Trace"
        : focus?.startsWith("Scenario") ? "Counterfactual Reasoning"
        : "Unknown";
      return { subtaskHint, focus, results: parsed?.results || [], raw: rawResult };
    });

    return { model, score, task, turns, judges, totalLatency: Number(mainConvo?.metrics?.totalBackendLatencyMs || 0), totalTokens: Number(mainConvo?.metrics?.outputTokens || 0) };
  };

  if (runs.length === 0) {
    return (
      <div style={{ textAlign:"center", padding:"40px 20px" }}>
        <div style={{ fontSize:36, marginBottom:12 }}>&#128270;</div>
        <div style={{ fontSize:14, fontWeight:500, color:COLORS.dark, marginBottom:8 }}>
          No example runs loaded.
        </div>
      </div>
    );
  }

  const parsed = runs.map(parseRun);
  const active = parsed[activeRun] || parsed[0];

  const getJudgesForSubtask = (subtask, focus) => {
    return active.judges.filter(j => {
      if (focus) return j.focus === focus;
      return j.subtaskHint === subtask && !j.focus;
    });
  };

  return (
    <div>
      <div style={{ display:"flex", gap:16, flexWrap:"wrap", alignItems:"center", marginBottom:16 }}>
        <div style={{ display:"flex", flexDirection:"column", gap:6 }}>
          <label htmlFor="example-select" style={{ fontSize:11, fontWeight:700, letterSpacing:0.4, textTransform:"uppercase", color:COLORS.mid }}>
            Example scenario
          </label>
          <select
            id="example-select"
            value={selectedExampleId}
            onChange={(event) => setSelectedExampleId(event.target.value)}
            style={{
              minWidth: 260,
              padding: "10px 12px",
              borderRadius: 8,
              border: "1px solid #ddd",
              background: "#fff",
              color: COLORS.dark,
              fontSize: 13,
              fontWeight: 600,
            }}
          >
            {EXAMPLE_OPTIONS.map((example) => (
              <option key={example.id} value={example.id}>
                {example.label} ({example.scenarioId})
              </option>
            ))}
          </select>
          <div style={{ fontSize: 12, color: COLORS.mid }}>
            {selectedExample?.blurb}
          </div>
        </div>
        <div style={{ display:"flex", gap:10, flexWrap:"wrap" }}>
          {parsed.map((p, i) => (
            <button key={i} onClick={() => { setActiveRun(i); setExpandedReq(null); }}
              style={{ padding:"8px 16px", borderRadius:8, cursor:"pointer",
                border: activeRun === i ? `2px solid ${p.score >= 0.7 ? "#00B894" : p.score >= 0.4 ? "#FDCB6E" : "#D63031"}` : "1.5px solid #e0e0e0",
                background: activeRun === i ? (p.score >= 0.7 ? "#E0F8F2" : p.score >= 0.4 ? "#FFF8E7" : "#FCE4E4") : "#fff",
              }}>
              <div style={{ fontSize:11, fontWeight:700, color:COLORS.dark }}>{p.model.split("/").pop()}</div>
              <div style={{ fontSize:18, fontWeight:800, color: p.score >= 0.7 ? "#00B894" : p.score >= 0.4 ? "#FDCB6E" : "#D63031" }}>{(p.score * 100).toFixed(0)}%</div>
            </button>
          ))}
        </div>
      </div>

      {active.turns.map((turn, i) => {
        const isExpanded = expandedReq === i;
        const subtaskJudges = getJudgesForSubtask(turn.subtask, null);
        const isJudged = turn.subtask !== "Effect Recognition" && turn.subtask !== "Violation Identification";
        let beliefJudges = [];
        let cfJudges = [];
        if (turn.subtask === "Belief Trace") {
          beliefJudges = active.judges.filter(j => j.subtaskHint === "Belief Trace" && j.focus);
        }
        if (turn.subtask === "Counterfactual Reasoning") {
          cfJudges = active.judges.filter(j => j.subtaskHint === "Counterfactual Reasoning" && j.focus);
        }
        const allRelevantJudges = turn.subtask === "Belief Trace" ? beliefJudges
          : turn.subtask === "Counterfactual Reasoning" ? cfJudges
          : subtaskJudges;
        const allPassed = allRelevantJudges.length > 0 && allRelevantJudges.every(j => j.results.every(r => r.passed));
        const anyFailed = allRelevantJudges.some(j => j.results.some(r => !r.passed));

        const TASK_COLORS = ["#6C5CE7","#0984E3","#00B894","#E17055","#FDCB6E","#D63031"];

        return (
          <div key={i} style={{ marginBottom:12, border:"1px solid #eee", borderRadius:10, overflow:"hidden" }}>
            <div onClick={() => setExpandedReq(isExpanded ? null : i)}
              style={{ padding:"12px 16px", cursor:"pointer", display:"flex", alignItems:"center", gap:12, background:isExpanded ? "#fafafa" : "#fff" }}>
              <div style={{ width:28, height:28, borderRadius:7, background:TASK_COLORS[i] + "18", display:"flex", alignItems:"center", justifyContent:"center", fontSize:12, fontWeight:700, color:TASK_COLORS[i] }}>{i+1}</div>
              <div style={{ flex:1 }}>
                <div style={{ fontSize:13, fontWeight:600, color:COLORS.dark }}>{turn.subtask}</div>
                <div style={{ fontSize:11, color:COLORS.mid }}>Weight: {(turn.weight * 100).toFixed(0)}%</div>
              </div>
              {isJudged && allRelevantJudges.length > 0 && (
                <div style={{ padding:"3px 10px", borderRadius:5, fontSize:11, fontWeight:600,
                  background: allPassed ? "#E0F8F2" : anyFailed ? "#FCE4E4" : "#FFF8E7",
                  color: allPassed ? "#00B894" : anyFailed ? "#D63031" : "#E17055",
                }}>
                  {allPassed ? "PASS" : "FAIL"}
                </div>
              )}
              {!isJudged && turn.mcqResult && (
                <div style={{ padding:"3px 10px", borderRadius:5, fontSize:11, fontWeight:600,
                  background: turn.mcqResult.passed ? "#E0F8F2" : "#FCE4E4",
                  color: turn.mcqResult.passed ? "#00B894" : "#D63031",
                }}>
                  {turn.mcqResult.passed ? "PASS" : "FAIL"}
                </div>
              )}
              {!isJudged && !turn.mcqResult && (
                <div style={{ padding:"3px 10px", borderRadius:5, fontSize:11, fontWeight:600, background:"#f0f0f0", color:COLORS.mid }}>MCQ</div>
              )}
              <span style={{ fontSize:14, color:COLORS.light, transform:isExpanded?"rotate(180deg)":"rotate(0)", transition:"transform 0.2s" }}>&#9660;</span>
            </div>
            {isExpanded && (
              <div style={{ padding:"0 16px 16px" }}>
                <div style={{ marginTop:12, marginBottom:12 }}>
                  <div style={{ fontSize:11, fontWeight:600, color:COLORS.mid, marginBottom:6 }}>Prompt</div>
                  <pre style={{ fontSize:11, lineHeight:1.5, color:COLORS.dark, background:"#f8f9fa", padding:12, borderRadius:8, whiteSpace:"pre-wrap", wordBreak:"break-word", overflow:"auto", margin:0, border:"1px solid #eee" }}>{turn.prompt}</pre>
                </div>
                <div style={{ marginBottom:12 }}>
                  <div style={{ fontSize:11, fontWeight:600, color:COLORS.accent, marginBottom:6 }}>Model response</div>
                  <pre style={{ fontSize:11, lineHeight:1.6, color:COLORS.dark, background:"#F0EEFF", padding:12, borderRadius:8, whiteSpace:"pre-wrap", wordBreak:"break-word", overflow:"auto", margin:0, border:`1px solid ${COLORS.accent}30` }}>{turn.response}</pre>
                </div>
                {turn.mcqResult && (
                  <div style={{ marginBottom:12 }}>
                    <div style={{ fontSize:11, fontWeight:600, color:"#0984E3", marginBottom:6 }}>Deterministic scoring</div>
                    <div style={{ padding:"10px 12px", borderRadius:6,
                      background: turn.mcqResult.passed ? "#E0F8F2" : "#FCE4E4",
                      border: `1px solid ${turn.mcqResult.passed ? "#00B89440" : "#D6303140"}`,
                      display:"flex", gap:8, alignItems:"flex-start",
                    }}>
                      <span style={{ fontSize:12, flexShrink:0 }}>{turn.mcqResult.passed ? "\u2705" : "\u274C"}</span>
                      <div style={{ flex:1 }}>
                        <div style={{ fontSize:12, fontWeight:600, color:COLORS.dark, marginBottom:4 }}>
                          {turn.mcqResult.passed ? "Correct" : "Incorrect"}
                        </div>
                        <div style={{ display:"flex", gap:16, fontSize:11, color:COLORS.mid, flexWrap:"wrap" }}>
                          <span>Gold: <strong style={{ color:COLORS.dark }}>{turn.mcqResult.gold}</strong></span>
                          <span>Predicted: <strong style={{ color: turn.mcqResult.passed ? "#00B894" : "#D63031" }}>{turn.mcqResult.predicted}</strong></span>
                          {turn.mcqResult.type === "f1" && (
                            <span>F1: <strong style={{ color: turn.mcqResult.f1 >= 1.0 ? "#00B894" : "#D63031" }}>{turn.mcqResult.f1.toFixed(2)}</strong></span>
                          )}
                        </div>
                        {turn.mcqResult.type === "f1" && !turn.mcqResult.passed && (
                          <div style={{ fontSize:11, color:COLORS.mid, marginTop:4 }}>
                            Violation ID requires exact set match (F1 = 1.0). Partial matches score 0.
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                )}
                {allRelevantJudges.length > 0 && (
                  <div>
                    <div style={{ fontSize:11, fontWeight:600, color:"#E17055", marginBottom:6 }}>Judge assessments</div>
                    {allRelevantJudges.map((j, ji) => (
                      <div key={ji} style={{ marginBottom:8 }}>
                        {j.focus && <div style={{ fontSize:10, fontWeight:600, color:COLORS.mid, marginBottom:4 }}>{j.focus}</div>}
                        {j.results.map((r, ri) => (
                          <div key={ri} style={{ display:"flex", gap:8, alignItems:"flex-start", marginBottom:4, padding:"8px 10px", borderRadius:6,
                            background: r.passed ? "#E0F8F2" : "#FCE4E4",
                            border: `1px solid ${r.passed ? "#00B89440" : "#D6303140"}`,
                          }}>
                            <span style={{ fontSize:12, flexShrink:0 }}>{r.passed ? "\u2705" : "\u274C"}</span>
                            <div style={{ flex:1 }}>
                              <div style={{ fontSize:11, fontWeight:600, color:COLORS.dark, marginBottom:2 }}>{r.criterion?.slice(0, 120)}{r.criterion?.length > 120 ? "..." : ""}</div>
                              <div style={{ fontSize:11, color:COLORS.mid }}>{r.reason}</div>
                            </div>
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            )}
          </div>
        );
      })}
      {(selectedExample?.observations || []).length > 0 && (
        <div style={{ padding:16, background:"#FFF3E0", borderRadius:10, border:"1px solid #FFE0B2" }}>
          <div style={{ fontSize:13, fontWeight:600, color:"#E65100", marginBottom:6 }}>Key observations from this comparison</div>
          <div style={{ fontSize:12, color:"#BF360C", lineHeight:1.7 }}>
            {(selectedExample?.observations || []).map((observation, index) => (
              <div key={index} style={{ marginTop: index === 0 ? 0 : 8 }}>
                {observation}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}


function LeaderboardTable() {
  return (
    <div style={{ border: "1px solid #eee", borderRadius: 12, overflowX: "auto", overflowY: "hidden", background: "#fff" }}>
      <div style={{ display: "grid", gridTemplateColumns: "70px minmax(220px, 1.6fr) minmax(120px, 1fr) 100px", minWidth: 560, padding: "12px 16px", background: "#f9f9f9", fontSize: 11, fontWeight: 700, color: COLORS.mid, letterSpacing: 0.3, textTransform: "uppercase" }}>
        <div>Rank</div>
        <div>Model</div>
        <div>Provider</div>
        <div style={{ textAlign: "right" }}>Score</div>
      </div>
      {LEADERBOARD.map((entry, index) => (
        <div
          key={entry.model}
          style={{
            display: "grid",
            gridTemplateColumns: "70px minmax(220px, 1.6fr) minmax(120px, 1fr) 100px",
            minWidth: 560,
            padding: "14px 16px",
            borderTop: index === 0 ? "none" : "1px solid #f0f0f0",
            fontSize: 13,
            alignItems: "center",
          }}
        >
          <div style={{ fontWeight: 700, color: entry.rank <= 3 ? COLORS.accent : COLORS.mid }}>#{entry.rank}</div>
          <div style={{ fontWeight: 600, color: COLORS.dark }}>{entry.model}</div>
          <div style={{ color: COLORS.mid }}>{entry.provider}</div>
          <div style={{ textAlign: "right", fontWeight: 700, color: COLORS.dark }}>{entry.score.toFixed(3)}</div>
        </div>
      ))}
    </div>
  );
}

function ScoringBreakdown() {
  return (
    <div style={{ display: "flex", gap: 4, height: 40, borderRadius: 8, overflow: "hidden" }}>
      {TASKS.map((t, i) => {
        const w = parseFloat(t.weight);
        return (
          <div key={i} style={{ width: `${w}%`, background: t.color, display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", minWidth: w > 15 ? 80 : 50 }}>
            <div style={{ fontSize: 10, fontWeight: 700, color: "#fff" }}>{t.weight}</div>
          </div>
        );
      })}
    </div>
  );
}

function CodeBlock({ code }) {
  return (
    <pre style={{ background: "#1e1e2e", color: "#cdd6f4", borderRadius: 10, padding: 20, fontSize: 12, lineHeight: 1.6, overflow: "auto", margin: 0, scrollbarWidth: "none", msOverflowStyle: "none" }}>
      <code>{code}</code>
    </pre>
  );
}

function CitationBlock() {
  const cite = `@misc{hsiung2026magicbench,
  title={{MagicBench: A Deception-Sensitive Cognitive Benchmark for LLMs}},
  author={Hsiung, Lei},
  year={2026},
  howpublished={\\url{https://hsiung.cc/MagicBench/}},
}`;
  const [copied, setCopied] = useState(false);
  return (
    <div style={{ position: "relative" }}>
      <CodeBlock code={cite} />
      <button onClick={() => { navigator.clipboard.writeText(cite); setCopied(true); setTimeout(() => setCopied(false), 2000); }}
        style={{ position: "absolute", top: 12, right: 12, fontSize: 11, padding: "4px 10px", borderRadius: 4, border: "1px solid #555", background: copied ? "#00B894" : "#333", color: "#fff", cursor: "pointer" }}>
        {copied ? "Copied" : "Copy"}
      </button>
    </div>
  );
}

function References() {
  const refs = [
    "Rensink, R.A. & Kuhn, G. (2015). A framework for using magic to study the mind. Frontiers in Psychology.",
    "Kuhn, G. et al. (2014). A psychologically-based taxonomy of misdirection. Frontiers in Psychology.",
    "Burnell, R. et al. (2026). Measuring Progress Toward AGI: A Cognitive Framework.",
    "Olson, J.A. et al. (2015). Children's responses to magic tricks. British J. of Developmental Psychology.",
    "Baillargeon, R. (1994). How do infants learn about the physical world? Current Directions in Psychological Science.",
  ];
  return (
    <div style={{ fontSize: 11, color: COLORS.mid, lineHeight: 1.7 }}>
      {refs.map((r, i) => (
        <p key={i} style={{ margin: "0 0 8px", breakInside: "avoid" }}>[{i + 1}] {r}</p>
      ))}
    </div>
  );
}

export default function App() {
  const [activeSection, setActiveSection] = useState("Overview");
  const scenarioRows = SCENARIOS.map((scenario) => ({
    id: scenario.id,
    title: scenario.title,
    description: scenario.description,
    effect: formatLabel(scenario.effect_type),
    methodFamilies: scenario.method_families.join(", "),
    tom: scenario.difficulty?.tom_need || 0,
  }));

  const scrollTo = (section) => {
    setActiveSection(section);
    const el = document.getElementById(section.toLowerCase());
    if (el) {
      const top = el.getBoundingClientRect().top + window.scrollY - SECTION_SCROLL_OFFSET;
      window.scrollTo({ top: Math.max(top, 0), behavior: "smooth" });
    }
  };

  return (
    <div style={{ fontFamily: "var(--font-sans)", color: COLORS.dark, background: "#fff" }}>
      <NavBar active={activeSection} onNav={scrollTo} />
      <Hero summary={DATASET_SUMMARY} />

      <Section id="overview" title="MagicBench: A Deception-Sensitive Cognitive Benchmark for LLMs" subtitle={<span style={{ fontWeight: 600 }}>Author: <a href="https://hsiung.cc" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.header_coral, textDecoration: "none" }}>Lei Hsiung</a> (Dartmouth College)</span>}>
        <Overview />
      </Section>

      <Section id="tasks" title="6 task types per scenario" subtitle="Each magic scenario generates 6 tasks covering different cognitive demands. Tasks 1-2 are deterministic MCQ. Tasks 3-6 are open-ended with LLM-as-judge scoring." bg={COLORS.bg}>
        <TaskCards />
        <div style={{ marginTop: 24, padding: 20, background: "#FFF3E0", borderRadius: 10, border: "1px solid #FFE0B2" }}>
          <div style={{ fontSize: 13, fontWeight: 600, color: "#E65100", marginBottom: 6 }}>All-or-nothing scoring for tasks 4 and 6</div>
          <div style={{ fontSize: 12, color: "#BF360C", lineHeight: 1.6 }}>
            Belief Trace requires correct audience-belief descriptions for ALL steps in the trick. Counterfactual Reasoning requires correct answers for ALL hypothetical conditions. Partial success scores 0 — this measures complete mechanistic understanding, not lucky guesses.
          </div>
        </div>
      </Section>

      <Section
        id="dataset"
        title="Dataset overview"
        subtitle={`${DATASET_SUMMARY.totalScenarios} scenarios spanning ${DATASET_SUMMARY.effectTypeCount} effect types and ${DATASET_SUMMARY.methodFamilyCount} method families.`}
      >
        <div style={{ display: "grid", gap: 32, marginBottom: 32 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.mid, marginBottom: 12 }}>Effect type</div>
            <EffectDistribution effects={DATASET_SUMMARY.effectDistribution} />
          </div>
        </div>
        <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.mid, marginBottom: 12 }}>Scenario sample</div>
        <ScenarioTable scenarios={scenarioRows} totalScenarios={DATASET_SUMMARY.totalScenarios} />
      </Section>

      <Section id="examples" title="Examples" subtitle="Select an example scenario, then see how Claude Opus 4.6, Gemini 3.1 Pro Preview, and GPT-5.4 reason on the same magic trick." bg={COLORS.bg}>
        <div style={{ marginBottom:32 }}>
          <ExampleViewer />
        </div>
      </Section>

      <Section id="evaluation" title="Cognitive Evaluation" subtitle="MagicBench maps each task to 5 difficulty axes and 10 cognitive faculties, aggregating them into a 5-dimension cognitive profile, producing a diagnostic fingerprint rather than a single score.">
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(280px, 1fr))", gap: 32 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.mid, marginBottom: 12 }}>5 difficulty axes</div>
            <DifficultyAxes />
          </div>
        </div>
        <div style={{ marginBottom:32 }}>
          <div style={{ fontSize:13, fontWeight:600, color:COLORS.mid, marginBottom:12 }}>5 cognitive profiles</div>
          <ProfileMap />
        </div>
      </Section>

      <Section
        id="leaderboard"
        title="Model Leaderboard"
        bg={COLORS.bg}
        subtitle={<span style={{ fontSize: 13, color: COLORS.mid }}>View on <a href="https://www.kaggle.com/benchmarks/lhsiung/magicbench" target="_blank" rel="noopener noreferrer" style={{ color: COLORS.accent, textDecoration: "underline" }}>Kaggle</a></span>}
      >
        <div style={{ display: "block", gap: 24, alignItems: "start" }}>
          <div>
            <LeaderboardTable />
          </div>
        </div>
      </Section>

      <Section id="references" title="Citation & References">
        <div style={{ display: "block", gap: 24, marginBottom: 32 }}>
          <div>
            <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.mid, marginBottom: 8 }}>If you find our work helpful or inspiring to your research, please cite our project as follows:</div>
            <CitationBlock />
          </div>
        </div>
        <div style={{ fontSize: 13, fontWeight: 600, color: COLORS.mid, marginBottom: 12 }}>References</div>
        <References />
      </Section>

      <footer style={{ padding: "32px 24px", borderTop: "1px solid #eee", textAlign: "center" }} bg={COLORS.bg}>
        <div style={{ fontSize: 13, color: COLORS.mid }}>
          MagicBench: A deception-sensitive cognitive benchmark for LLMs
        </div>
        <div style={{ fontSize: 11, color: COLORS.light, marginTop: 4 }}>
        © Copyright 2026 Lei Hsiung.
        </div>
      </footer>
    </div>
  );
}
